<div class="header">
    <img src="https://fodimi.pl/img/site_logo/logo_4.png">
</div>

<div class="content-container">
    <img src="assets/img/done.svg" width="100">
    <h4 class="mb-4 mt-4">{{ 'AUTH.CONTACT_FORM_SUCCESS' | translate }}</h4>
    <div class="text-center">
        <a  href="https://fodimi.pl"><button class="btn btn-primary">{{ 'AUTH.BACK_TO_HOME' | translate }}</button></a>
    </div>
</div>
